import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";
import { UnitImage } from "@/components/units/unit/info/unitImage";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { UnitPromotions } from "@/components/units/unit/info/unitPromotions";
import React from "react";

export const JourneyHeader: React.FC = React.memo(() => {
    const unitContext = useUnitItemContext();
    const journeyContext = useUnitJourneyContext();

    const { unitJourneyStep, setUnitJourneyStep, stepList } = journeyContext;
    const { unitGroup } = unitContext;

    const stepDetails = {
        "rent-reserve-quote": {
            title: "Rent or Reserve",
            description: "",
        },
        vbp: {
            title: "",
            description: "",
        },
        funnel: { title: "", description: "" },
    }[unitJourneyStep] || {
        title: "Unknown Step",
        description: "Please proceed to the next step.",
    };

    const handleGoBack = () => {
        const currentStepIndex = stepList.findIndex((element) => element === unitJourneyStep);
        setUnitJourneyStep(stepList[currentStepIndex - 1]);
    }

    return (
        <div className="tw:flex tw:flex-wrap">
            <div className="unit-journey__unit-details">
                <UnitImage
                    className="unit-journey__unit-image tw:mr-3 !tw:max-w-[75px]"
                    length={unitGroup.representative_unit.length}
                    width={unitGroup.representative_unit.width}
                />
                <h4>
                    {unitGroup.representative_unit.width !== 0 && unitGroup.representative_unit.length !== 0
                        ? `${unitGroup.representative_unit.width}' x ${unitGroup.representative_unit.length}'`
                        : unitGroup.representative_unit.width !== 0
                            ? `${unitGroup.representative_unit.width}'`
                            : unitGroup.representative_unit.length !== 0
                                ? `${unitGroup.representative_unit.length}'`
                                : ''}
                </h4>
                <p>({unitGroup.representative_unit.area} sq. ft.)</p>
            </div>
            <div className="unit-journey__header">
                <h3 className="unit-journey__title tw:font-bold">Grab Your Space Today</h3>
                <p className="unit-journey__step-status">
                    Step {stepList.indexOf(unitJourneyStep) + 1} of{" "}
                    {stepList.length}
                </p>
                {stepList.indexOf(unitJourneyStep) > 0 && (
                    <Button className="unit-journey__back-link tw:font-bold" variant="link" onClick={handleGoBack}>Go Back</Button>
                )}
            </div>
            <Separator className="tw:my-4 tw:border-b tw:border-gray-200" />
            <div className="tw:w-full tw:flex tw:flex-row tw:flex-wrap tw:md:flex-nowrap tw:justify-between">
                <div className="unit-journey__step-description">
                    <h3 className="unit-journey__step-title tw:font-bold">
                        {stepDetails.title}
                    </h3>
                    <p className="unit-journey__step-description">
                        {stepDetails.description}
                    </p>
                </div>
                <div className="unit-journey__promotions">
                    {unitJourneyStep != "funnel" && unitJourneyStep != "vbp" ? <UnitPromotions promotions={unitGroup.rates.promo_rates} /> : null}
                </div>
            </div>
        </div>
    );
});
